import { Instagram } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

export const FooterSection = () => {
  const { t } = useLanguage();

  return (
    <footer className="relative py-12 bg-[#060606] border-t border-[#1A1A1A]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex flex-col items-center md:items-start gap-3">
            <span className="text-lg font-bold tracking-tight text-[#C9A84C] font-heading">Next Level</span>
            <p className="text-[#555] text-xs">&copy; {new Date().getFullYear()} Next Level. All rights reserved.</p>
          </div>
          <nav className="flex items-center gap-6 flex-wrap justify-center">
            <Link to="/imprint" className="text-[#8A8680] text-xs hover:text-[#C9A84C] transition-colors duration-300">{t.footer.impressum}</Link>
            <Link to="/privacy" className="text-[#8A8680] text-xs hover:text-[#C9A84C] transition-colors duration-300">{t.footer.datenschutz}</Link>
            <a href="#" className="text-[#8A8680] text-xs hover:text-[#C9A84C] transition-colors duration-300">{t.footer.cookies}</a>
          </nav>
          <div className="flex items-center gap-4">
            <a href="#" className="w-9 h-9 rounded-lg bg-[#111111] border border-[#1F1F1F] flex items-center justify-center text-[#8A8680] hover:text-[#C9A84C] hover:border-[#C9A84C]/30 transition-all duration-300" aria-label="Instagram"><Instagram size={16} /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};
